var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new-appstore-channel-form" } },
    [
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("appStore.channelName")))]),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: {
                    "validate-status": _vm.getErrorStatus("channelName"),
                    help: _vm.getErrorMessage("channelName"),
                  },
                },
                [
                  _c("a-input", {
                    ref: "channelName",
                    attrs: {
                      placeholder: _vm.$t("appStore.channelName"),
                      name: "channelName",
                    },
                    model: {
                      value: _vm.form.channelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channelName", $$v)
                      },
                      expression: "form.channelName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "credentials-section" }, [
            _c("div", { staticClass: "section-title" }, [
              _c("i", { staticClass: "material-icons" }, [_vm._v("key")]),
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("appStore.credentials")) +
                  "\n                "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "help-text" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("appStore.credentialsHelp")) +
                  "\n                    "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://appstoreconnect.apple.com/access/api",
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    "\n                        App Store Connect API\n                    "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("appStore.issuerId")))]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      "validate-status": _vm.getErrorStatus("issuerId"),
                      help: _vm.getErrorMessage("issuerId"),
                    },
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        placeholder: _vm.$t("appStore.issuerIdPlaceholder"),
                        name: "issuerId",
                      },
                      model: {
                        value: _vm.form.issuerId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "issuerId", $$v)
                        },
                        expression: "form.issuerId",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("appStore.keyId")))]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      "validate-status": _vm.getErrorStatus("keyId"),
                      help: _vm.getErrorMessage("keyId"),
                    },
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        placeholder: _vm.$t("appStore.keyIdPlaceholder"),
                        name: "keyId",
                      },
                      model: {
                        value: _vm.form.keyId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "keyId", $$v)
                        },
                        expression: "form.keyId",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("appStore.privateKey")))]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      "validate-status": _vm.getErrorStatus("privateKey"),
                      help: _vm.getErrorMessage("privateKey"),
                    },
                  },
                  [
                    _c("a-textarea", {
                      attrs: {
                        placeholder: _vm.$t("appStore.privateKeyPlaceholder"),
                        name: "privateKey",
                        rows: 6,
                      },
                      model: {
                        value: _vm.form.privateKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "privateKey", $$v)
                        },
                        expression: "form.privateKey",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "connect-body" }, [
            _c(
              "div",
              [
                _c("a-checkbox", {
                  attrs: { checked: _vm.termOfService },
                  on: {
                    change: function ($event) {
                      return _vm.acceptTermOfService("pp")
                    },
                  },
                }),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("search.integration.readAndAgree")) +
                      "\n                        "
                  ),
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.acceptTermOfService("pp")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("search.integration.privatePolicy")))]
                  ),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("message.and")) +
                      "\n                        "
                  ),
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.acceptTermOfService("tac")
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("search.integration.termsAndCondition"))
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "SupsisButton",
              { attrs: { ghost: "" }, on: { click: _vm.handleCancel } },
              [_vm._v(" " + _vm._s(_vm.$t("wp.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: {
                  disabled: !_vm.canValidate || _vm.validating,
                  loading: _vm.validating,
                },
                on: { click: _vm.validateCredentials },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("appStore.validateCredentials")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: {
                  primary: "",
                  disabled:
                    !_vm.termOfService ||
                    _vm.loading ||
                    !_vm.credentialsValidated,
                  loading: _vm.loading,
                },
                on: { click: _vm.handleSubmit },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("appStore.connectToAppStore")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.termOfServiceModal
        ? _c("TermOfService", {
            attrs: { type: _vm.termOfServiceModal },
            on: {
              agree: _vm.acceptedTermOfService,
              cancel: function ($event) {
                _vm.termOfServiceModal = null
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }